import Modal from "../modals/Modal";
import ModalMobile from "../modals/ModalMobile";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  selectLoginModal,
  setShowForgotPassword,
  setShowUserLoginModal,
  setShowUserRegisterModal,
  setShowWelcomeModal,
} from "../../features/modals/modalsSlice";
import {
  logout,
  selectDetectedCountry,
  selectLogged,
  setUserLoginDetails,
  setVerificaciones,
} from "../../features/user/userSlice";
import { useSelector, useDispatch } from "react-redux";
import Swal from "sweetalert2";
import { PRIMARY, SECONDARY } from "../../const/colors";
import { useNavigate } from "react-router-dom";
import { errorNotification } from "../../utils/toastNotifications";
import { API_URL } from "../../const/api";
import axios from "axios";
import { useCookies } from "react-cookie";
import FormLogin from "./FormLogin";
import { Helmet } from "react-helmet";
import { clearLimites, setLimites } from "../../features/limitaciones/limitacionesSlice";
import { comprobarTiempoInactivo } from "../../utils/tools";

const initialForm = {
  user: "",
  password: "",
};

const Login = () => {
  const [form, setForm] = useState(initialForm);
  const [error, setError] = useState(initialForm);
  const [loading, setLoading] = useState(false);
  const isLoggedIn = useSelector(selectLogged);
  const loginModal = useSelector(selectLoginModal);
  const country = useSelector(selectDetectedCountry);
  const [t] = useTranslation("global");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [user, setUser] = useState(null)
  const [intentos, setIntentos] = useState(0)

  const [cookies, setCookie] = useCookies(["user"]);

  const validateForm = () => {
    if (!form.user || !form.password) {
      setError({
        user: !form.user ? t("login.enter-user") : "",
        password: !form.password ? t("login.enter-password") : "",
      });
      return false;
    } else {
      setError(initialForm);
      return true;
    }
  };

  const incrementarIntentosFallidos = (_user) => {
      if(user!==null && user !== _user) {
        setIntentos(0)
        setUser(_user)
      } else {
        setIntentos(intentos+1)
        setUser(_user)
      }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      setLoading(true);

      incrementarIntentosFallidos(form.user)

      try {
        const body = {...form, pais: country}
        const res = await axios.post(API_URL + "auth", body);
        if (res.data.status === 1) {
          localStorage.setItem("MBIFON", 0)
          dispatch(setUserLoginDetails(res.data));

          if (res.data.estado !== "1") {
            //usuario bloqueado
            dispatch(logout({}));
            dispatch(clearLimites({}));
            //navigate('/');
            Swal.fire({
              title: `"${res.data.user}": ${t("alert.errorNotificationRetiro-72")}`,
              text: t("alert.errorNotificationRetiro-71"),
              allowOutsideClick: false,
              icon: "error",
              background: SECONDARY,
              color: "#fff",
              showConfirmButton: true,
              confirmButtonText: "OK",
              confirmButtonColor: PRIMARY,
            }).then((result) => {
              if (result.isConfirmed) {
                setForm(initialForm);
                window.location.href = "/";
              }
            });
          } else {
            let now = new Date();
            let minutes = 90;
            now.setTime(now.getTime() + minutes * 60 * 1000);
            const enc = await axios.post(API_URL + "guardar", {
              a: form.user,
              b: form.password,
            });
            if (enc.data) {
              setCookie("MBA", enc.data.aenc, { path: "/", expires: now });
              setCookie("MBB", enc.data.benc, { path: "/", expires: now });
            }
            if (res.data.change_passwd === "1") {
              navigate("/cambiarPassword");
            } else {
              if (res.data.change_passwd === "2") {
                navigate("/completarDatos");
              } else {
                handleLogin(res.data.user, res.data.id);
              }
            }
          }
          setLoading(false);
        } else {
          errorNotification(t("alert.errorNotificationRetiro-49"));
          setLoading(false);
          if(intentos>=2) {
            setError({...error, intentosFallidos: "Ha alcanzado el límite de intentos, su usuario será bloqueado en el próximo intento fallido."})
          }
          if(intentos>=3) {
            const body = {...form, pais: country}
            const res = await axios.post(API_URL + "bloquearUsuario", body);
            if(res.data.response===1) {
              Swal.fire({
                title: `Usuario Bloqueado!`,
                text: 'Ha excedido el límite de intentos para ingresar a la plataforma y hemos bloqueado su usuario, comuníquese con soporte técnico para mas detalles.',
                icon: "error",
                background: SECONDARY,
                color: "#fff",
                confirmButtonColor: PRIMARY,
                allowOutsideClick: false, // Evita que se cierre haciendo clic fuera
              });
            }
          }
        }
      } catch (error) {
        errorNotification(t("alert.errorNotificationRetiro-6"));
        setLoading(false);
      }
    }
  };

  const getLimitaciones = async (id_uo, token='') => {
    let body = { id_uo, token };
    try {
      const res = await axios.post(API_URL + "getLimitaciones", body);
      if (res.data.response !== null) {
        dispatch(setLimites(res.data.response));
        const fecha_config = res.data.response.fecha_config;
        const tiempo_inactivo = res.data.response.tiempo_inactivo;
        const limitaciones = res.data.response;

        //validamos si se cumplio el tiempo de inactividad
        if(tiempo_inactivo > 0 && fecha_config && comprobarTiempoInactivo(fecha_config)) {
          // se cumplio el tiempo de inactividad y lo seteamos a 0
          body = {...body, ...res.data.response, tiempo_inactivo: 0, fecha_config: null}
          const resSet = await axios.post(API_URL + "setLimitaciones", body);
          if(resSet.data.response==='ok') {
            dispatch(setLimites({...limitaciones, tiempo_inactivo: 0, fecha_config: null}))
            return true;
          }
        } else {
          if(tiempo_inactivo>0) {
            return false
          } else {
            return true
          }
        }
      }

      return true;
    } catch (error) {
      //console.log(error);
    }
  };

  const getVerificacion = async (id_uo) => {
    return true
    const res = await axios.post(API_URL + "getVerificaciones", {
      id_uo,
    });

    if (res.data.status === 1) {
      const {
        moneda,
        validacion_documento,
        verified
      } = res.data.response;

      dispatch(setVerificaciones({validacion_documento, verified}))

      if(moneda!=='Sol'||id_uo!=='26628') return true
      if(validacion_documento==1||verified==1) return true
      return false
    }
  }

  const handleLogin = async (nombre, id_uo,) => {
    Swal.fire({
      title: `${t("login.welcome")} ${nombre}!`,
      text: t("login.login-succes"),
      icon: "success",
      background: SECONDARY,
      color: "#fff",
      confirmButtonColor: PRIMARY,
      allowOutsideClick: false, // Evita que se cierre haciendo clic fuera
    });
    handleClose();
    dispatch(setShowWelcomeModal(true));

    const noHayLimite = await getLimitaciones(id_uo); 
    const verificado = await getVerificacion(id_uo); 

    if(noHayLimite && verificado) {
      if (window.location.pathname === t("header.link-1.url")) navigate(0);
      else navigate(t("header.link-1.url"));
    } else {
      navigate("/")
    }

  };

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
    validateForm();
  };
  const showRegister = () => {
    dispatch(setShowUserRegisterModal(true));
    handleClose();
  };
  const handleClose = () => {
    setForm(initialForm);
    setError(initialForm);
    setLoading(false);
    dispatch(setShowUserLoginModal(false));
  };

  const olvidoClave = () => {
    dispatch(setShowForgotPassword(true));
    dispatch(setShowUserLoginModal(false));
  };

  return (
    !isLoggedIn && (
      <>
        <Helmet>
          <link rel="canonical" href="https://masterbets365.com/LogIn" />
        </Helmet>
        <Modal
          open={loginModal}
          maxWidth="sm"
          fullWidth={false}
          handleClose={handleClose}
          children={
            <FormLogin
              handleClose={handleClose}
              handleChange={handleChange}
              error={error}
              form={form}
              loading={loading}
              handleSubmit={handleSubmit}
              showRegister={showRegister}
              olvidoClave={olvidoClave}
            />
          }
        />
        <ModalMobile
          open={loginModal}
          handleClose={handleClose}
          children={
            <FormLogin
              handleClose={handleClose}
              handleChange={handleChange}
              error={error}
              form={form}
              loading={loading}
              handleSubmit={handleSubmit}
              showRegister={showRegister}
              olvidoClave={olvidoClave}
            />
          }
        />
      </>
    )
  );
};

export default Login;
